import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '../services';

export const authGuard = (): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isTokenValid()) {
    auth.clear();
    return router.createUrlTree(['/login']);
  }
  return true;
};
